import type { TFunction } from 'i18next';
import {
  ADDON_RATE_UNIT,
  type AddonRateUnit,
  type ListingAddon,
  type TripAddon,
} from 'src/common/types/common/Addons';

type i18nCommonKey = string;
export const rateUnitKeyMap: Record<AddonRateUnit, i18nCommonKey> = {
  [ADDON_RATE_UNIT.PER_HOUR]: 'addon--per-hour',
  [ADDON_RATE_UNIT.PER_TRIP]: 'addon--per-trip',
  [ADDON_RATE_UNIT.PER_PERSON]: 'addon--per-person',
  [ADDON_RATE_UNIT.PER_UNIT]: 'addon--per-unit',
  [ADDON_RATE_UNIT.PERCENTAGE_OF_TRIP_COST]: 'addon--of-trip-cost',
};

export const formatAddonPrice = (
  addon: ListingAddon | TripAddon,
  /** common.json */
  t: TFunction,
): { amount: string; type: string; formatted: string } => {
  const unit = t(rateUnitKeyMap[addon.rate_units]);
  if (addon.rate_units === ADDON_RATE_UNIT.PERCENTAGE_OF_TRIP_COST) {
    return {
      amount: `${Number(addon.percentage)}%`,
      type: unit,
      formatted: `${Number(addon.percentage)}% ${unit}`,
    };
  }
  return {
    amount: `${addon.currency.symbol}${addon.amount}`,
    type: unit,
    formatted: `${addon.currency.symbol}${addon.amount} ${unit}`,
  };
};

export default formatAddonPrice;
